import { render, staticRenderFns } from "./GameScatterChart.vue?vue&type=template&id=eed95b80&scoped=true"
import script from "./GameScatterChart.vue?vue&type=script&lang=js"
export * from "./GameScatterChart.vue?vue&type=script&lang=js"
import style0 from "./GameScatterChart.vue?vue&type=style&index=0&id=eed95b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed95b80",
  null
  
)

export default component.exports